export const isStandalone = (): boolean => {
  return window.parent === window;
};

export const isFederated = (): boolean => {
  return window.parent !== window;
};

export const getEnvironment = (): 'standalone' | 'federated' => {
  return isStandalone() ? 'standalone' : 'federated';
};
